import {
	Component,
	EventEmitter,
	Input,
	OnDestroy,
	OnInit,
	Output
} from '@angular/core';
import { QuoteUpdateService } from '@services/quote/quote-update.service';
import { InvoicesDataProvider } from '@services/invoice/invoices-data-service/invoices.data.service';
import { FormControl } from '@angular/forms';
import { Product } from '@models/models';
import { debounceTime, filter, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
	selector: 'discount-create-block',
	template: require('./discount-create-block.component.html'),
	styles: [require('./discount-create-block.component.scss')]
})
export class DiscountCreateBlockComponent implements OnInit, OnDestroy {
	@Input('discount') discount;
	@Input('index') index;
	@Input('currencySymbol') currencySymbol;
	@Input('discountsNames') discountsNames;
	@Input('taxPercentage') taxPercentage;
	@Output('changeDiscount') changeDiscount = new EventEmitter();
	@Output('deleteDiscount') deleteDiscount = new EventEmitter();

	chosenItem: Product;
	priceField: FormControl;
	discountTemplateId = -1;
	unsubscribe: Subject<void> = new Subject<void>();
	amountChanged: Subject<number> = new Subject<number>();

	constructor(
		private quoteUpdateService: QuoteUpdateService,
		private invoiceDataService: InvoicesDataProvider
	) {}

	ngOnInit(): void {
		this.priceField = new FormControl();
		this.chosenItem =
			this.discount === null
				? this.setDefaultDiscount()
				: this.setChosenDiscount();
		this.subscribeToInputChange();
		this.subscribeToAmountChange();
	}

	ngOnDestroy(): void {
		this.unsubscribe.next();
		this.unsubscribe.complete();
	}

	subscribeToInputChange(): void {
		this.priceField.valueChanges
			.pipe(takeUntil(this.unsubscribe))
			.subscribe((amount): void => {
				this.amountChanged.next(!amount ? 0 : -amount);
			});
	}

	subscribeToAmountChange(): void {
		this.amountChanged
			.pipe(
				takeUntil(this.unsubscribe),
				debounceTime(250)
			)
			.subscribe((amount): void => {
				this.chosenItem.price = amount;
				this.calculateAmount(this.chosenItem);
			});
	}

	validateDiscountOnBlur(): void {
		const priceValue = this.priceField.value;
		this.chosenItem.price = -priceValue;
		this.calculateAmount(this.chosenItem, true);
	}

	updateDiscount(discountId): void {
		this.discountTemplateId = parseInt(discountId);
		if (this.discountTemplateId === -1) {
			this.chosenItem = Object.assign(
				this.chosenItem,
				this.setDefaultDiscount()
			);
		} else {
			this.chosenItem = JSON.parse(
				JSON.stringify(
					this.discountsNames.filter(product => product.id === +discountId)[0]
				)
			);
			this.setDiscountPrice(+this.chosenItem.price);
			this.chosenItem = Object.assign(this.chosenItem, {
				fromSettings: true,
				discount: 0,
				quantity: 1,
				summary: {
					total: 0
				},
				recommended: false,
				mandatory: true
			});
		}
		this.calculateAmount(this.chosenItem, true);
	}

	removeDiscount(index): void {
		this.deleteDiscount.emit(index);
	}

	checkKey(event): void {
		if (
			event.keyCode === 189 ||
			event.keyCode === 109 ||
			event.key === '-' ||
			event.keyCode === 69
		) {
			event.preventDefault();
		}
	}

	private calculateAmount(item, needToEmit?): void {
		const discoutToSend = JSON.parse(JSON.stringify(item));
		const data = {
			products: [discoutToSend],
			tax: this.taxPercentage
		};
		this.invoiceDataService.calculateInvoiceSummary(data).subscribe(
			(calculatedData): void => {
				this.chosenItem.amount = calculatedData.items[0].summary.total;
				this.chosenItem.summary = calculatedData.items[0].summary;
				if (needToEmit) {
					this.emitDiscountChange();
				}
				this.quoteUpdateService.setNextUpdateProduct(null, this.chosenItem);
			},
			(error): void => console.log(error)
		);
	}

	private setChosenDiscount(): Product {
		this.setDiscountPrice(this.discount.price);
		this.setDiscountTemplate();
		return Object.assign(this.discount, {
			discount: 0,
			quantity: 1,
			summary: {
				total: 0
			},
			recommended: false,
			mandatory: true
		});
	}

	private setDiscountTemplate() {
		this.discountsNames.forEach((product): void => {
			switch (product.id) {
				case this.discount.id:
					this.discountTemplateId = this.discount.id;
					break;
				case null:
					this.discountTemplateId = -1;
					break;
				default:
					break;
			}
		});
	}

	private setDefaultDiscount(): Product {
		this.priceField.setValue(null);
		let chosenItem = QuoteUpdateService.setEmptyProduct('GIFT');
		chosenItem = Object.assign(chosenItem, {
			price: 0,
			discount: 0,
			quantity: 1,
			description: '<p>Fixed fee discount.</p>',
			name: '',
			summary: {
				total: 0
			},
			taxType: 'NO_TAX',
			recommended: false,
			mandatory: true
		});

		return chosenItem;
	}

	private setDiscountPrice(price: number): void {
		const str = price.toString();
		const correctPrice = Number(str.substring(1, str.length)).toFixed(2);
		this.priceField.setValue(correctPrice);
	}

	private emitDiscountChange(): void {
		const objToEmit = {
			index: this.index,
			type: 'discount',
			product: this.chosenItem
		};
		this.changeDiscount.emit(objToEmit);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=kkml25e9zf!./web/modern/components/quotes/common/discount-create-block/discount-create-block.component.ts